import { fromJS } from 'immutable'
import {
  CLIENT_MASTER_GET_REQUEST,
  CLIENT_MASTER_GET_SUCCESS,
  CLIENT_MASTER_GET_FAILURE,
  CLIENT_MASTER_GET_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CLIENT_MASTER_GET_REQUEST:
      return state
        .set('isFetching', true)
    case CLIENT_MASTER_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('client', fromJS(action.payload.client))
    case CLIENT_MASTER_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CLIENT_MASTER_GET_RESET:
      return state
        .delete('client')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client/client-master-get-reducer.js